module.exports = __webpack_public_path__ + "media/podcast1.3cba75e1.mp3";